import { render, staticRenderFns } from "./N11Finansman.vue?vue&type=template&id=2081a254"
import script from "./N11Finansman.vue?vue&type=script&lang=js"
export * from "./N11Finansman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports